<app-downtime-active-message></app-downtime-active-message>
<div *transloco="let translate">
    <div class="new-recon-process mat-elevation-z8">
        <div class="border-recon">
            <span class="process-header">
                <span [textContent]="translate('Run Reconciliation')"></span>
            </span>
            <div class="reconHeader items-center">
                <material-button
                    [classList]="['whitespace-nowrap']"
                    [text]="translate('View All Templates')"
                    (click)="viewTemplates()"></material-button>
                <mat-form-field appearance="outline" subscriptSizing="dynamic" appRemoveAriaOwns class="mx-3">
                    <mat-select [placeholder]="translate('Select template')" [(value)]="appliedTemplateId" [disableOptionCentering]="true">
                        <mat-option [value]="">
                            <em [textContent]="'--' + translate('Please select') + '--'"></em>
                        </mat-option>
                        <mat-form-field class="searchContentClass">
                            <input
                                matInput
                                [placeholder]="translate('Search template')"
                                type="text"
                                [(ngModel)]="searchedTemplate"
                                (click)="$event.stopPropagation()" />
                            <material-button
                                buttonType="icon"
                                [size]="'small'"
                                matSuffix
                                (buttonClicked)="searchedTemplate = ''"
                                [prefixIcon]="searchedTemplate ? 'close' : 'search'"
                                [classList]="['searchEntitiesIcons']"></material-button>
                        </mat-form-field>
                        <mat-option *ngFor="let template of templates | multiFilter : searchedTemplate" [value]="template.templateId">
                            <span [textContent]="template.templateName"></span>
                        </mat-option>
                        <div class="noTemplatesMsg" *ngIf="(templates | multiFilter : searchedTemplate)?.length === 0">
                            <span [textContent]="translate('No Template Found')"></span>
                        </div>
                    </mat-select>
                </mat-form-field>
                <material-button
                    [classList]="['whitespace-nowrap']"
                    [color]="'primary'"
                    [text]="translate('Apply Template')"
                    (click)="applyReconTemplate()"></material-button>
            </div>
        </div>
        <div class="process-body">
            <div class="process-steps">
                <div class="process-step request-step">
                    <div class="step-left-content">
                        <span class="name" [textContent]="translate('Request Attributes')"></span>
                        <span class="material-icons info-icon" [matTooltip]="translate('Information will shown here...')">
                            info_outline
                        </span>
                    </div>
                    <div class="step-right-content">
                        <ng-container *ngIf="filingAttributeFields?.length > 0; else noFilingAttributes">
                            <div class="row">
                                <ng-container *ngFor="let field of filingAttributeFields">
                                    <div class="col-3 tolerance-step" *ngIf="!field.autoCalculate">
                                        <filingattribute-field
                                            [field]="field"
                                            [record]="filingAttributeFields"
                                            [service]="app"
                                            [type]="'filingDate'"
                                            [classList]="field.uiType === 'TEXTFIELD' ? 'filing-input-field' : ''"></filingattribute-field>
                                    </div>
                                </ng-container>
                            </div>
                        </ng-container>
                    </div>
                </div>
                <div class="process-step matching-step">
                    <div class="step-left-content">
                        <span class="name" [textContent]="translate('Matching Criteria')"></span>
                        <span class="material-icons info-icon" [matTooltip]="translate('Information will shown here...')">
                            info_outline
                        </span>
                    </div>
                    <div class="step-right-content">
                        <div class="matches-container row">
                            <div class="match flex" *ngFor="let step of reconConfig?.steps" [title]="step.name">
                                <material-checkbox
                                    [showName]="true"
                                    [name]="step.name"
                                    [id]="step.id"
                                    [model]="step.selected"
                                    [description]="step.description"
                                    (modelChange)="step.selected = $event"
                                    [disabled]="step.mandatory"
                                    [labelTextClass]="'!w-[20rem] d-block'"></material-checkbox>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="process-step source-step" *ngFor="let source of reconConfig?.sources; let i = index">
                    <div class="step-left-content">
                        <span class="name" [textContent]="source.name"></span>
                    </div>
                    <div class="step-right-content">
                        <div class="sources-container">
                            <ng-container *ngTemplateOutlet="sourceInputTemplate; context: { source: source, index: i }"></ng-container>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-end mt-5 mr-7">
                <material-button
                    class="mx-2"
                    [color]="'default'"
                    [text]="translate('Cancel')"
                    (buttonClicked)="cancelNewProcessCreation()"></material-button>
                <material-button
                    class="mx-2"
                    [hidden]="hideTemplateButton"
                    [color]="'primary'"
                    [text]="selectedTemplateId ? translate('Update Template') : translate('Save As Template')"
                    (buttonClicked)="saveOrUpdateTemplate()"></material-button>
                <material-button
                    class="mx-2"
                    [color]="'primary'"
                    [text]="translate('Run Reconciliation')"
                    (buttonClicked)="validateAndSubmitData()"></material-button>
            </div>
        </div>
    </div>
    <ng-template #noFilingAttributes>
        <div class="noTrasformationSelectedCls">
            <span class="renderContent" [textContent]="translate('No Pre-Capture Attributes found')"></span>
        </div>
    </ng-template>

    <ng-template #sourceInputTemplate let-source="source" let-index="index">
        <mat-tab-group
            class="source-tab-group"
            (selectedTabChange)="(source.selected && inputTypeNames[source.selected.value])"
            (selectedIndexChange)="source.selected.setValue($event); onInputTypeTabChange()"
            [selectedIndex]="source.selected.value">
            <ng-container>
                <mat-tab *ngFor="let type of inputTypeNames">
                    <ng-template mat-tab-label>
                        <span [textContent]="translate(type)"></span>
                    </ng-template>
                    <ng-container *ngIf="type === 'Upload File'">
                        <div class="header">
                            <span
                                [textContent]="
                                    translate('You need to select the data transformation first before uploading any file')
                                "></span>
                        </div>
                        <div class="source-transformations row">
                            <div class="transformations col-4 ml-n3">
                                <material-selectgroup
                                    [appearance]="'outline'"
                                    [required]="true"
                                    [options]="source.transformations"
                                    [placeholder]="translate('Select Data Transformation')"
                                    [model]="source.selectedTransformationName"
                                    [optionDisplayNameProperty]="'displayName'"
                                    [optionValueProperty]="'id'"
                                    (modelChange)="source.selectedTransformationName = $event; getSelectedTransformation(source)"
                                    [groupDisplayNameProperty]="'orgName'"
                                    [groupValueProperty]="'transformations'"
                                    [errors]="source?.transformationError || []"
                                    [title]="source.selectedTransformationName"></material-selectgroup>
                            </div>
                            <div class="col-8 row p-0">
                                <div class="src-details" *ngFor="let src of source.transformationSources">
                                    <div
                                        class="file-upload col-2.5"
                                        [ngClass]="{ 'file-uploaded': src.fileName, fileNameClass: src.fileName }">
                                        <app-file-upload
                                            [data]="attachmentData"
                                            [clearFiles]="clearFiles"
                                            (newValue)="fileChanged($event, source, src)"
                                            (fileName)="changedFileName($event, source, src)"></app-file-upload>
                                    </div>
                                    <div class="file-name col-5" *ngIf="!source.uploadError" [matTooltip]="src.fileName">
                                        <span [textContent]="src.fileName"></span>
                                    </div>
                                    <div class="file-name col-5 error-file-name" *ngIf="source.uploadError">
                                        <span
                                            [textContent]="
                                                src.fileName ? src.fileName : translate('Please upload file from computer')
                                            "></span>
                                    </div>
                                    <div class="src-info col-3.5">
                                        <p class="elip-txt" [matTooltip]="translate('Source Name') + ' : ' + src.name">
                                            <span [textContent]="translate('Source Name') + ' :'"></span>
                                            <span class="fileType" [textContent]="src.name | pascalToCamel"></span>
                                        </p>
                                        <p class="elip-txt" [matTooltip]="translate('Supported file type') + ' : ' + src.sourceDataFormat">
                                            <span [textContent]="translate('Supported file type') + ' :'"></span>
                                            <span class="fileType" [textContent]="src.sourceDataFormat"></span>
                                        </p>
                                        <p>
                                            <span [textContent]="translate('Download Source Template') + ' :'"></span>
                                            <span
                                                class="downloadLink"
                                                [matTooltip]="translate('Download Source Template')"
                                                (click)="downloadSourceTemplateUrl(source, src)"
                                                [textContent]="translate('Download')"></span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container *ngIf="type === 'Pull the source file through an App'">
                        <div class="header">
                            <span
                                [textContent]="
                                    translate('You need to select the data transformation first before adding search conditions')
                                "></span>
                        </div>
                        <div class="source-transformations row">
                            <div class="transformations col-4 ml-n3">
                                <material-selectgroup
                                    [appearance]="'outline'"
                                    [required]="true"
                                    [options]="source.assetToAssetTransformations"
                                    [placeholder]="translate('Select Transformation')"
                                    [model]="source.selectedAssetToAssetTrnsName"
                                    [optionDisplayNameProperty]="'displayName'"
                                    [optionValueProperty]="'id'"
                                    (modelChange)="
                                        source.selectedAssetToAssetTrnsName = $event; getSelectedAssetToAssetTransformation(source)
                                    "
                                    [groupDisplayNameProperty]="'orgName'"
                                    [title]="source.selectedAssetToAssetTrnsName"
                                    [groupValueProperty]="'transformations'"></material-selectgroup>
                            </div>
                        </div>
                        <div class="source-filters" *ngIf="source.selectedAssetToAssetTrnsName?.length > 0">
                            <div class="header">
                                <span class="search" [textContent]="translate('Search')"></span>
                                <span class="check-tenants">
                                    <material-checkbox
                                        [name]="translate('Check Related Tenants')"
                                        [model]="source.unitConsiderationEnabled"
                                        [showName]="true"
                                        (modelChange)="source.unitConsiderationEnabled = $event"></material-checkbox>
                                </span>
                            </div>
                            <div class="">
                                <ng-container *ngTemplateOutlet="customSearch; context: { source: source }"></ng-container>
                            </div>
                        </div>
                    </ng-container>
                </mat-tab>
            </ng-container>
        </mat-tab-group>
    </ng-template>

    <ng-template #noTransformation>
        <div class="noTrasformationSelectedCls">
            <span class="renderContent" [textContent]="translate('Please select a transformation')"></span>
        </div>
    </ng-template>

    <ng-template #customSearch let-source="source">
        <ng-container *ngIf="source.assetToAssetTransformationMetaData?.uid">
            <mat-tab-group class="w-100" [selectedIndex]="source.selectedSearchTab">
                <mat-tab [label]="translate('Rules')">
                    <app-search-builder [search]="source.search" searchType="SEARCH"></app-search-builder>
                    <div class="d-flex align-items-center justify-content-end pb-1 mt-4">
                        <material-button
                            class="noOutline submitColor mx-2"
                            [color]="'primary'"
                            [text]="!source.search.criteriaUpdated ? translate('Add Criteria') : translate('Update Criteria')"
                            (buttonClicked)="source.search.buildCriterias()"></material-button>
                    </div>
                </mat-tab>
                <mat-tab [label]="translate('Relations')">
                    <div class="relationsTab pt-4">
                        <div class="queryBuilderMainCntr">
                            <app-search-builder
                                [search]="source.search"
                                [showQueryBuilderDirectly]="true"
                                searchType="RELATION"></app-search-builder>
                        </div>
                        <div class="d-flex align-items-center justify-content-end mt-4">
                            <material-button
                                [color]="'primary'"
                                class="noOutline submitColor"
                                [text]="translate('Apply Relations')"
                                (buttonClicked)="source.search.applyRelations()"></material-button>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </ng-container>
    </ng-template>
</div>
